export type SortDirection = "asc" | "desc";

/**
 * A URL sort key as a PocketBase sort expression. Only keys in `fields` are allowed (the URL is
 * user input); anything else sorts by newest.
 */
export function sortBy(
  fields: Record<string, string>,
  sort: string | undefined,
  direction: SortDirection | undefined,
): string {
  const field = sort ? fields[sort] : undefined;
  return field ? `${direction === "desc" ? "-" : ""}${field}` : "-created";
}
